import React from "react";
import { LobbyState } from "../../../../services/api/LobbyApi";
import styles from "./LobbyStateBadge.module.scss";

interface LobbyStateBadgeProps {
  state: LobbyState;
}

const STATE_CONFIG: Record<LobbyState, { label: string; className: string }> = {
  OPEN: { label: "Open", className: "open" },
  PREPARING: { label: "Preparing", className: "preparing" },
  ACTIVE: { label: "Active", className: "active" },
  COMPLETED: { label: "Completed", className: "completed" },
  CANCELLED: { label: "Cancelled", className: "cancelled" },
};

const LobbyStateBadge: React.FC<LobbyStateBadgeProps> = ({ state }) => {
  const config = STATE_CONFIG[state];

  return (
    <span className={`${styles.badge} ${styles[config.className]}`}>
      {config.label}
    </span>
  );
};

export default LobbyStateBadge;
